import React, { Fragment, useEffect, useMemo, useState } from 'react'

import {
  Box,
  Display,
  Heading1,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { useMarketingPricingConfig } from '@library/api-pricing'
import { useIsTaperedDiscountCurveEnabled } from '@library/landing-pages'

import { boxSizes as boxSize, getHeroDetails } from 'routes/BoxPrices/boxPricesConfig'
import { locationQuery } from 'selectors/routing'

import { BoxPricesContent } from './BoxPricesContent'
import { BoxPricesWithAllPortions } from './BoxPricesWithAllPortions/BoxPricesWithAllPortions'

const BoxPricesComponent = () => {
  const pricingConfig = useMarketingPricingConfig()
  const isTaperedDiscountCurveEnabled = useIsTaperedDiscountCurveEnabled()
  const { pmaxPortions, pmaxRecipes } = useSelector(locationQuery)

  const [pmaxApplied, setPmaxApplied] = useState(false)
  const [activeNumPortion, setActiveNumPortion] = useState(2)
  const [activeRecipes, setActiveRecipes] = useState(boxSize[2].length - 1)

  const numPersonsToBoxDescriptors = pricingConfig?.numPersonsToBoxDescriptors ?? {}
  const availableBoxSizes = useMemo(
    () => pricingConfig?.availableBoxSizes ?? [],
    [pricingConfig?.availableBoxSizes],
  )

  const handleActivePortionSize = (portionSize: number) => {
    setActiveNumPortion(portionSize)
    setActiveRecipes(boxSize[portionSize].length - 1)
  }

  useEffect(() => {
    if (availableBoxSizes?.length && pmaxPortions && pmaxRecipes && !pmaxApplied) {
      const pmaxPortionsNum = Number(pmaxPortions)
      if (
        availableBoxSizes.includes(pmaxPortionsNum) &&
        boxSize[pmaxPortions]?.includes(pmaxRecipes)
      ) {
        setActiveNumPortion(pmaxPortionsNum)
        setActiveRecipes(boxSize[pmaxPortions].indexOf(pmaxRecipes))
        setPmaxApplied(true)
      }
    }
  }, [pmaxRecipes, pmaxPortions, availableBoxSizes, pmaxApplied])

  return (
    <Fragment>
      <Box data-testid="boxPricesComponentLoaded">
        <Space size={[6, 8]} direction="vertical" />
        <Heading1 textAlign={TextAlign.Center}>{getHeroDetails().header}</Heading1>
        <Space size={[6, 8]} direction="vertical" />
        <Box
          display={Display.Flex}
          justifyContent={JustifyContent.Center}
          gap={8}
          data-testid="boxPricesWithAllPortions"
        >
          {availableBoxSizes.length > 0 && (
            <BoxPricesWithAllPortions
              boxInfo={numPersonsToBoxDescriptors}
              onClickPortionSize={handleActivePortionSize}
              activeNumPortion={activeNumPortion}
              portionSizes={availableBoxSizes as unknown as string[]}
              activeRecipes={activeRecipes}
              setActiveRecipes={setActiveRecipes}
              isTaperedDiscountCurveEnabled={isTaperedDiscountCurveEnabled}
            />
          )}
        </Box>
        <Space size={[8, 18]} />
        <BoxPricesContent
          activeNumPortion={activeNumPortion}
          isTaperedDiscountCurveEnabled={isTaperedDiscountCurveEnabled}
        />
      </Box>
    </Fragment>
  )
}

export { BoxPricesComponent }
